var _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCerrarSesion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cerrar-sesion",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.274,
    height: 65.353,
    viewBox: "0 0 38.274 65.353",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.103 0.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10",
    "data-name": "Grupo 10",
    transform: "translate(-0.103 -0.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9",
    "data-name": "Grupo 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M69.489,10.716a1.777,1.777,0,0,0,1.785-1.768V4.366A4.416,4.416,0,0,0,66.819,0H45.455A4.416,4.416,0,0,0,41,4.366V46.953a4.416,4.416,0,0,0,4.455,4.366H66.819a4.416,4.416,0,0,0,4.455-4.366V42.371a1.785,1.785,0,0,0-3.57,0v4.581a.86.86,0,0,1-.886.829H45.455a.86.86,0,0,1-.886-.829V4.366a.86.86,0,0,1,.886-.829H66.819a.86.86,0,0,1,.886.829V8.948A1.777,1.777,0,0,0,69.489,10.716Z",
    transform: "translate(-41)",
    fill: "#696969"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12",
    "data-name": "Grupo 12",
    transform: "translate(12.897 14.542)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11",
    "data-name": "Grupo 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M215.346,142.067l-9.595-9.357a1.8,1.8,0,1,0-2.517,2.581l6.422,6.263H192.419a1.8,1.8,0,0,0,0,3.606h17.237l-6.422,6.263a1.8,1.8,0,1,0,2.517,2.581l9.595-9.357A1.8,1.8,0,0,0,215.346,142.067Z",
    transform: "translate(-190.616 -132.199)",
    fill: "#696969"
  }))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Salir",
    transform: "translate(0.103 62.353)",
    fill: "#696969",
    fontSize: 11,
    fontFamily: "WorkSans-Regular, Work Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SALIR"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerrarSesion);
export default __webpack_public_path__ + "static/media/cerrar-sesion.6ddc4f01416a4139f0968e1b6fd854d9.svg";
export { ForwardRef as ReactComponent };